import * as React from 'react';
import { List } from './List';
import { Routes, Route, useParams } from 'react-router-dom';
import { NotFound } from '../NotFound';
import { NotAllowed } from '../NotAllowed';
import { AppSection } from '../../components/AppSection';
import { CreateOrUpdate } from './CreateOrUpdate';
import { serviceLocator } from '../../services';
import { MainPadding } from '../../components/MainPadding';
import { Update } from './Update';
import { RestrictedSection, Tests } from '../../components/RestrictedSection';

const uiService = serviceLocator.getUIService();

const restricTest = Tests.or([Tests.hasAnyAgency(),Tests.hasRole("admin")]);

function EditQualityConfigRoute() {
    const params = useParams();
    return (<Update qualityCheckConfigId={params.identifier} agency={uiService.getSelectedAgency()||''} />);
}

function CreateQualityConfigRoute() {
    return (<CreateOrUpdate config={null} parentConfig={null} agency={uiService.getSelectedAgency()||''} />);
}

export class QualityConfigs extends React.Component<any,any>{

    public render(){

        if(!uiService.getSelectedAgency()){
            return (<MainPadding><p>Please, select an agency.</p></MainPadding>);
        }

        return (<React.Fragment>
            <AppSection section="quality-check-config" />
            <RestrictedSection test={restricTest} render={(forbidden)=>(
                <Routes>
                    {forbidden && <Route path="*" element={<NotAllowed />} />}
                    <Route path="create" element={<CreateQualityConfigRoute />} />
                    <Route path=":identifier/edit" element={<EditQualityConfigRoute />} />
                    <Route path="" element={<List />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            )} />
        </React.Fragment>)
    }
}
